var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceWashing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.767,
    height: 56.251,
    viewBox: "0 0 54.767 56.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38751",
    "data-name": "\\uADF8\\uB8F9 38751",
    transform: "translate(-1032.438 -1988.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38747",
    "data-name": "\\uADF8\\uB8F9 38747",
    transform: "translate(1033.638 1990.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19474",
    "data-name": "\\uD328\\uC2A4 19474",
    d: "M4073.467,4220.585v-28.313h-6.218V4183.4l-10.572-7.412-.863-.009c-.026,2.822-4.776,4.331-10.182,4.543-5.683.226-12.156-1.323-12.156-4.649,0-.036,0-.07.005-.105l-.864-.009-11.51,7.641v37.184s0,8.747,8.474,8.747h35.239C4073.813,4229.332,4073.467,4220.585,4073.467,4220.585Z",
    transform: "translate(-4021.107 -4175.76)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_157",
    "data-name": "\\uC120 157",
    y2: 28.314,
    transform: "translate(46.143 16.512)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_158",
    "data-name": "\\uC120 158",
    x2: 14.011,
    y2: 52.479,
    transform: "translate(11.51)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_159",
    "data-name": "\\uC120 159",
    x1: 12.141,
    y2: 44.414,
    transform: "translate(23.429 0.229)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19475",
    "data-name": "\\uD328\\uC2A4 19475",
    d: "M4024.306,4178.876v14.945l6.844,7.3-4.86,9.473,14.582,16.831",
    transform: "translate(-4019.64 -4174.332)",
    fill: "#fff",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19476",
    "data-name": "\\uD328\\uC2A4 19476",
    d: "M4054.926,4178.876v14.945l-6.844,7.3,4.86,9.473-14.582,16.831",
    transform: "translate(-4013.201 -4174.332)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_78",
    "data-name": "\\uD0C0\\uC6D0 78",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(1064 2024)",
    fill: "#f09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceWashing);
export default __webpack_public_path__ + "static/media/icon-service-washing.382206b21d0e7880761604db2fa39c06.svg";
export { ForwardRef as ReactComponent };